import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NutrigenicRoutingModule } from './nutrigenic-routing.module';
import { NutrigenicComponent } from './nutrigenic.component';
import { HeaderComponent } from './layout/components/header/header.component';
import { MenubarModule } from 'primeng/menubar';
import { HomeComponent } from './pages/home/home.component';
import { WhatMakesComponent } from './pages/home/what-makes/what-makes.component';
import { DividerModule } from 'primeng/divider';
import { CarouselModule } from 'primeng/carousel';
import { FooterComponent } from './layout/components/footer/footer.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { BlogComponent } from './pages/blog/blog.component';
import { BlogDetailComponent } from './pages/blog/blog-detail/blog-detail.component';
import { DialogModule } from 'primeng/dialog';
import { RatingModule } from 'primeng/rating';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrustpilotCardComponent } from './layout/components/trustpilot-card/trustpilot-card.component';
import { OrangeButtonComponent } from './layout/components/orange-button/orange-button.component';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProfileComponent } from './pages/profile/profile.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { MyOrdersComponent } from './pages/profile/my-orders/my-orders.component';
import { AccountComponent } from './pages/profile/account/account.component';
import { AuthService } from './services/auth/auth.service';
import { JwtTokenService } from './services/auth/jwt-token.service';
import { ApiServiceCall } from './services/global.apiServicecall';
import { PasswordModule } from 'primeng/password';
import { GoogleSigninButtonDirective, GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { UserProfileService } from './services/profile/user-profile.service';
import { ResizeDetectionService } from './services/resize-detection.service';
import { ActivateComponent } from './pages/activate/activate.component';
import { BlogService } from './services/blog/blog.service';
import { HomeService } from './services/home/home.service';
import { OurShopService } from './services/our-shop/our-shop.service';
import { PlanService } from './services/plan/plan.service';
import { ChartModule } from 'primeng/chart';
import { NgxStripeModule } from 'ngx-stripe';
import { SliderComponent } from './pages/slider/slider.component';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { NgxGpAutocompleteModule } from "@angular-magic/ngx-gp-autocomplete";
import { Loader } from '@googlemaps/js-api-loader';
import { NgxSpinnerModule } from "ngx-spinner";
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { CalendarModule } from 'primeng/calendar';
import { CountdownModule } from 'ngx-countdown';
import { FaqComponent } from './pages/faq/faq.component';
import { AccordionModule } from 'primeng/accordion';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { TabMenuModule } from 'primeng/tabmenu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { InputSwitchModule } from 'primeng/inputswitch';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { OverlayModule } from 'primeng/overlay';
import { ReviewsComponent } from './layout/components/reviews/reviews.component';
import { HowItWorksComponent } from './layout/components/how-it-works/how-it-works.component';
import { CookieBannerComponent } from './layout/components/cookie-banner/cookie-banner.component';
import { EditWeekPlanComponent } from './pages/edit-week/edit-week-plan/edit-week-plan.component';
import { HammerModule} from "@angular/platform-browser";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { CurrentMenuSliderComponent } from './layout/components/current-menu-slider/current-menu-slider.component';
import { NewMealCardComponent } from './layout/components/new-meal-card/new-meal-card.component';
import { CurrentMenuComponent } from "./pages/current-menu/current-menu.component";
import { OfferBannerComponent } from "./layout/components/offer-banner/offer-banner.component";
import { HelpSectorComponent } from './layout/components/help-sector/help-sector.component';
import { LuckyWinnerBannerComponent } from './layout/components/lucky-winner-banner/lucky-winner-banner.component';
import { PaginationComponent } from './layout/components/pagination/pagination.component';
import { SocialMediaBarComponent } from './layout/components/social-media-bar/social-media-bar.component';
import { AllergiesDialogComponent } from './layout/components/allergies-dialog/allergies-dialog.component';
import { OrderFlowComponent } from './pages/order-flow/order-flow.component';
import { OrderSummaryComponent } from './pages/order-flow/order-summary/order-summary.component';
import { OrderCheckoutComponent } from './pages/order-flow/order-checkout/order-checkout.component';
import { LoginDialogComponent } from './layout/components/login-dialog/login-dialog.component';
import { SignupDialogComponent } from './layout/components/signup-dialog/signup-dialog.component';
import { SignupConfirmationDialogComponent } from './layout/components/signup-confirmation-dialog/signup-confirmation-dialog.component';
import { ForgotPasswordDialogComponent } from './layout/components/forgot-password-dialog/forgot-password-dialog.component';
import { AuthDialogsComponent } from './layout/components/auth-dialogs/auth-dialogs.component';
import { NgForBusinessComponent } from './pages/ng-for-business/ng-for-business.component';
import { ImagesLoghiComponent } from './layout/components/images-loghi/images-loghi.component';
import { ContactFormComponent } from './pages/ng-for-business/contact-form/contact-form.component';
import { BusinessHeroComponent } from './pages/ng-for-business/components/business-hero/business-hero.component';
import { MealSolutionComponent } from './pages/ng-for-business/components/meal-solution/meal-solution.component';
import { FeatureGridComponent } from './pages/ng-for-business/components/feature-grid/feature-grid.component';
import { AltSolutionsComponent } from './pages/ng-for-business/components/alt-solutions/alt-solutions.component';
import { ArrowDividerComponent } from './pages/ng-for-business/components/arrow-divider/arrow-divider.component';
import { MealDietComponent } from './pages/ng-for-business/components/meal-diet/meal-diet.component';
import { ProcessStepsComponent } from './layout/components/process-steps/process-steps.component';
import { ContactSectionComponent } from './pages/ng-for-business/components/contact-section/contact-section.component';
import { SelectMealsComponent } from './pages/order-flow/select-meals/select-meals.component';
import { OrderFlowHeaderComponent } from './layout/components/order-flow-header/order-flow-header.component';
import { MealsSearchBarComponent } from './layout/components/meals-search-bar/meals-search-bar.component';
import {EliteAthletesComponent} from "./pages/home/elite-athletes/elite-athletes.component";
import { ChangePasswordComponent } from './layout/components/change-password/change-password.component';
import { HealthHelpComponent } from './layout/components/health-help/health-help.component';
import { HowItWorksPageComponent } from './pages/how-it-works-page/how-it-works-page.component';
import { DisclaimerComponent } from './layout/components/disclaimer/disclaimer.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { AddressSearchComponent } from './layout/components/address-search/address-search.component';
import { CancelSubscriptionComponent } from './pages/profile/my-orders/cancel-subscription/cancel-subscription.component';
import { MyOrderDetailsComponent } from './pages/profile/my-orders/my-order-details/my-order-details.component';
import { OrderCardComponent } from './pages/profile/my-orders/order-card/order-card.component';

@NgModule({
    declarations: [
        NutrigenicComponent,
        HeaderComponent,
        FooterComponent,
        HomeComponent,
        WhatMakesComponent,
        CurrentMenuComponent,
        AboutUsComponent,
        BlogComponent,
        BlogDetailComponent,
        ProfileComponent,
        MyOrdersComponent,
        AccountComponent,
        ActivateComponent,
        SliderComponent,
        FaqComponent,
        TermsComponent,
        PrivacyComponent,
        ReviewsComponent,
        CookieBannerComponent,
        EditWeekPlanComponent,
        LuckyWinnerBannerComponent,
        PaginationComponent,
        SocialMediaBarComponent,
        AllergiesDialogComponent,
        OrderFlowComponent,
        OrderSummaryComponent,
        OrderCheckoutComponent,
        LoginDialogComponent,
        SignupDialogComponent,
        SignupConfirmationDialogComponent,
        ForgotPasswordDialogComponent,
        AuthDialogsComponent,
        NgForBusinessComponent,
        SelectMealsComponent,
        OrderFlowHeaderComponent,
        MealsSearchBarComponent,
        ChangePasswordComponent,
        HealthHelpComponent,
        HowItWorksPageComponent,
        DisclaimerComponent,
        ForgotPasswordComponent,
        CancelSubscriptionComponent,
        MyOrderDetailsComponent,
        OrderCardComponent
    ],

    imports: [
        FontAwesomeModule,
        CommonModule,
        ReactiveFormsModule,
        NutrigenicRoutingModule,
        MenubarModule,
        DividerModule,
        CarouselModule,
        DialogModule,
        RatingModule,
        FormsModule,
        OrangeButtonComponent,
        TrustpilotCardComponent,
        DropdownModule,
        MultiSelectModule,
        PasswordModule,
        GoogleSigninButtonModule,
        ScrollPanelModule,
        ChartModule,
        SidebarModule,
        ButtonModule,
        NgxStripeModule,
        NgxGpAutocompleteModule,
        NgxSpinnerModule,
        MenuModule,
        ToastModule,
        CalendarModule,
        CountdownModule,
        AccordionModule,
        TabMenuModule,
        AutoCompleteModule,
        AvatarModule,
        AvatarGroupModule,
        InputSwitchModule,
        RadioButtonModule,
        CheckboxModule,
        OverlayModule,
        HammerModule,
        CurrentMenuSliderComponent,
        NewMealCardComponent,
        OfferBannerComponent,
        HelpSectorComponent,
        ImagesLoghiComponent,
        ContactFormComponent,
        BusinessHeroComponent,
        MealSolutionComponent,
        FeatureGridComponent,
        AltSolutionsComponent,
        ArrowDividerComponent,
        MealDietComponent,
        ProcessStepsComponent,
        ContactSectionComponent,
        HowItWorksComponent,
        EliteAthletesComponent,
        AddressSearchComponent
    ],
    exports: [GoogleSigninButtonDirective],
    providers: [
        {
            provide: Loader,
            useValue: new Loader({
              apiKey: 'AIzaSyD0ZWNUyNrGkj6LKeilMR-9ywxKzRttc8U',
              libraries: ['places'],
              region: 'GB'
            })
        },
        ApiServiceCall,
        AuthService,
        JwtTokenService,
        UserProfileService,
        ResizeDetectionService,
        BlogService,
        HomeService,
        OurShopService,
        PlanService
    ]
})
export class NutrigenicModule { }
